export const FETCH_RUNS = 'FETCH_RUNS';
export const FETCH_RUNS_SUCCESS = 'FETCH_RUNS_SUCCESS';
export const FETCH_RUNS_FAIL = 'FETCH_RUNS_FAIL';

/* Keeping the list of runs up to date while a run in it is active. */
export const FOLLOW_RUNS_LIST = 'FOLLOW_RUNS_LIST';
export const STOP_FOLLOWING_RUNS_LIST = 'STOP_FOLLOWING_RUNS_LIST';
export const FETCH_RUNS_RETRY = 'FETCH_RUNS_RETRY';
export const FETCH_RUNS_GAVE_UP = 'FETCH_RUNS_GAVE_UP';

export const FETCH_SCENARIOS = 'FETCH_SCENARIOS';
export const FETCH_SCENARIOS_SUCCESS = 'FETCH_SCENARIOS_SUCCESS';
export const FETCH_SCENARIOS_FAIL = 'FETCH_SCENARIOS_FAIL';

export const FETCH_SIMULATION_LIMITS = 'FETCH_SIMULATION_LIMITS';
export const FETCH_SIMULATION_LIMITS_SUCCESS =
    'FETCH_SIMULATION_LIMITS_SUCCESS';
export const FETCH_SIMULATION_LIMITS_FAIL = 'FETCH_SIMULATION_LIMITS_FAIL';

export const CREATE_RUN = 'CREATE_RUN';
export const CREATE_RUN_SUCCESS = 'CREATE_RUN_SUCCESS';
export const CREATE_RUN_FAIL = 'CREATE_RUN_FAIL';

/* Following a run: reading it every few seconds, with its results, until it is in a terminal state or the screen is left. */
export const FOLLOW_RUN = 'FOLLOW_RUN';
export const STOP_FOLLOWING_RUN = 'STOP_FOLLOWING_RUN';
export const FETCH_RUN_SUCCESS = 'FETCH_RUN_SUCCESS';
export const FETCH_RUN_FAIL = 'FETCH_RUN_FAIL';
export const FETCH_RUN_RETRY = 'FETCH_RUN_RETRY';
export const FETCH_RUN_RESULTS_SUCCESS = 'FETCH_RUN_RESULTS_SUCCESS';
export const FETCH_RUN_RESULTS_FAIL = 'FETCH_RUN_RESULTS_FAIL';

/* The run that a new run is made from ("Run again"). */
export const FETCH_RUN_TO_COPY = 'FETCH_RUN_TO_COPY';
export const FETCH_RUN_TO_COPY_SUCCESS = 'FETCH_RUN_TO_COPY_SUCCESS';
export const FETCH_RUN_TO_COPY_FAIL = 'FETCH_RUN_TO_COPY_FAIL';

export const CANCEL_RUN = 'CANCEL_RUN';
export const DELETE_RUN = 'DELETE_RUN';
export const RUN_ACTION_SUCCESS = 'RUN_ACTION_SUCCESS';
export const RUN_ACTION_FAIL = 'RUN_ACTION_FAIL';
